var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("el-collapse-transition", [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.show,
            expression: "show",
          },
        ],
      },
      [
        _c(
          "el-row",
          { attrs: { gutter: 60 } },
          [
            _c(
              "el-col",
              { attrs: { span: 8 } },
              [
                _c(
                  "el-form-item",
                  {
                    staticClass: "form-item-title",
                    attrs: {
                      prop: "contactsNameTwo",
                      rules: _vm.rules.validateNames,
                      label: _vm.$t("retailStoresInfo.form.moreInfo.contact2"),
                    },
                  },
                  [
                    _c("el-input", {
                      attrs: {
                        maxlength: "10",
                        placeholder:
                          _vm.type !== "edit"
                            ? ""
                            : _vm.$t("retailStoresInfo.input.inputHolder"),
                        clearable: "",
                        disabled: _vm.type !== "edit",
                      },
                      model: {
                        value: _vm.form.contactsNameTwo,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "contactsNameTwo", $$v)
                        },
                        expression: "form.contactsNameTwo",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-col",
              { attrs: { span: 8 } },
              [
                _c(
                  "el-form-item",
                  {
                    staticClass: "form-item-title",
                    attrs: {
                      prop: "contactsMobileTwo",
                      rules: _vm.rules.validatePhone,
                      label: _vm.$t("retailStoresInfo.form.moreInfo.mobile2"),
                    },
                  },
                  [
                    _c("el-input", {
                      attrs: {
                        placeholder:
                          _vm.type !== "edit"
                            ? ""
                            : _vm.$t("retailStoresInfo.input.inputHolder"),
                        clearable: "",
                        disabled: _vm.type !== "edit",
                      },
                      model: {
                        value: _vm.form.contactsMobileTwo,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "contactsMobileTwo", $$v)
                        },
                        expression: "form.contactsMobileTwo",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-col",
              { attrs: { span: 8 } },
              [
                _c(
                  "el-form-item",
                  {
                    staticClass: "form-item-title",
                    attrs: {
                      prop: "contactsNameThree",
                      rules: _vm.rules.validateNames,
                      label: _vm.$t("retailStoresInfo.form.moreInfo.contact3"),
                    },
                  },
                  [
                    _c("el-input", {
                      attrs: {
                        maxlength: "10",
                        placeholder:
                          _vm.type !== "edit"
                            ? ""
                            : _vm.$t("retailStoresInfo.input.inputHolder"),
                        clearable: "",
                        disabled: _vm.type !== "edit",
                      },
                      model: {
                        value: _vm.form.contactsNameThree,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "contactsNameThree", $$v)
                        },
                        expression: "form.contactsNameThree",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "el-row",
          { attrs: { gutter: 60 } },
          [
            _c(
              "el-col",
              { attrs: { span: 8 } },
              [
                _c(
                  "el-form-item",
                  {
                    staticClass: "form-item-title",
                    attrs: {
                      prop: "contactsMobileThree",
                      rules: _vm.rules.validatePhone,
                      label: _vm.$t("retailStoresInfo.form.moreInfo.mobile3"),
                    },
                  },
                  [
                    _c("el-input", {
                      attrs: {
                        placeholder:
                          _vm.type !== "edit"
                            ? ""
                            : _vm.$t("retailStoresInfo.input.inputHolder"),
                        clearable: "",
                        disabled: _vm.type !== "edit",
                      },
                      model: {
                        value: _vm.form.contactsMobileThree,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "contactsMobileThree", $$v)
                        },
                        expression: "form.contactsMobileThree",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-col",
              { attrs: { span: 8 } },
              [
                _c(
                  "el-form-item",
                  {
                    staticClass: "form-item-title",
                    attrs: {
                      label: _vm.$t("retailStoresInfo.form.moreInfo.remark1"),
                    },
                  },
                  [
                    _c("el-input", {
                      attrs: { maxlength: "10", clearable: "", disabled: "" },
                      model: {
                        value: _vm.form.remarkOne,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "remarkOne", $$v)
                        },
                        expression: "form.remarkOne",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-col",
              { attrs: { span: 8 } },
              [
                _c(
                  "el-form-item",
                  {
                    staticClass: "form-item-title",
                    attrs: {
                      label: _vm.$t("retailStoresInfo.form.moreInfo.remark2"),
                    },
                  },
                  [
                    _c("el-input", {
                      attrs: { maxlength: "10", clearable: "", disabled: "" },
                      model: {
                        value: _vm.form.remarkTwo,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "remarkTwo", $$v)
                        },
                        expression: "form.remarkTwo",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "el-row",
          { attrs: { gutter: 60 } },
          [
            _c(
              "el-col",
              { attrs: { span: 8 } },
              [
                _c(
                  "el-form-item",
                  {
                    staticClass: "form-item-title",
                    attrs: {
                      label: _vm.$t("retailStoresInfo.form.moreInfo.remark3"),
                    },
                  },
                  [
                    _c("el-input", {
                      attrs: { maxlength: "10", clearable: "", disabled: "" },
                      model: {
                        value: _vm.form.remarkThree,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "remarkThree", $$v)
                        },
                        expression: "form.remarkThree",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }